<template>
	<div>
		<v-app-bar app absolute dark prominent flat shrink-on-scroll scroll-threshold="500" scroll-target="#app-content"
			src="../assets/images/banner.png" id="NavBar">
			<template v-slot:img="{ props }">
				<v-img v-bind="props" class="nav-bar-background"></v-img>
			</template>

			<v-row class="nav-bar-row">
				<v-app-bar-nav-icon @click.stop="toggleDrawer = !toggleDrawer" class="hamburger-menu"></v-app-bar-nav-icon>
				<div id="NavBarTitle">Oscar Artunes</div>
				<v-spacer></v-spacer>
				<div class="small-screen">
					<v-btn text dark>
						<router-link to="/">
							{{ $t('navbar.title', { title: $t(`navbarChoices[0].text`) }) }}
						</router-link>
					</v-btn>
					<v-btn text dark>
						<router-link to="/featured">
							{{ $t('navbar.title', { title: $t(`navbarChoices[1].text`) }) }}
						</router-link>
					</v-btn>
					<v-btn text dark>
						<router-link to="/gallery">
							{{ $t('navbar.title', { title: $t(`navbarChoices[2].text`) }) }}
						</router-link>
					</v-btn>
					<v-btn text dark>
						<router-link to="/contact">
							{{ $t('navbar.title', { title: $t(`navbarChoices[3].text`) }) }}
						</router-link>
					</v-btn>
				</div>
				<v-col class="language-switch" cols="4" md="2" sm="3">
					<v-select v-model="$i18n.locale" :items="languages" item-text="text" item-value="value">
						<template slot="selection" slot-scope="{ item }">
							<img :src="item.flag" alt="id_flag" style="padding-right:10px" />
							{{ item.text }}
						</template>
						<template slot="item" slot-scope="{ item }" style="font-style: kalam">
							<img :src="item.flag" alt="id_flag" style="padding-right:10px" />
							{{ item.text }}
						</template>
					</v-select>
				</v-col>
			</v-row>
		</v-app-bar>
		<v-navigation-drawer app v-model="toggleDrawer" disable-resize-watcher>
			<v-list dense>
				<v-list-item v-for="(item, i) in items" :key="item.id" router :to="item.route">
					<v-list-item-icon>
						<v-icon v-html="icons[i]"></v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							{{ $t('navbar.title', { title: $t(`navbarChoices[${item.title}].text`) }) }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
	</div>
</template>

<script>
import Constants from '@/Constants.js'

export default {
	name: 'NavBar',
	data: () => ({
		languages: Constants.languages,
		icons: ['$vuetify.icons.home', '$vuetify.icons.featured', '$vuetify.icons.image', '$vuetify.icons.email'],
		items: [
			{ id: 1, title: 0, route: '/' },
			{ id: 2, title: 1, route: '/featured' },
			{ id: 3, title: 2, route: '/gallery' },
			{ id: 4, title: 3, route: '/contact' },
		],
		toggleDrawer: false,
	}),
}
</script>

<style lang="scss" scoped>
#NavBar {
	.small-screen {
		@media only screen and (max-width: 760px) {
			display: none;
		}
	}

	#NavBarTitle {
		@media only screen and (max-width: 760px) {
			padding-top: 8px;
			height: 60px;
		}
	}

	.language-switch {
		@media only screen and (max-width: 760px) {
			padding-top: 10px;
		}

		padding: 0;
	}

	.hamburger-menu {
		@media only screen and (max-width: 767px) {
			display: block;
		}

		@media only screen and (min-width: 768px) {
			display: none;
		}
	}

	.nav-bar-row {
		margin-top: 0.5rem;
	}

	.nav-bar-background {
		opacity: 0.2;
	}

	a {
		font-weight: bold;
		color: #feffff;

		text-decoration: none;

		&.router-link-exact-active {
			color: #6699cc;
		}
	}
}
</style>
